import { useElementSizeObservable } from '@jotta/hooks'
import type { VirtualListOptions } from '@jotta/virtualized'
import { VirtualList } from '@jotta/virtualized'
import styles from '@jotta/virtualized/VirtualList.module.scss'
import Debug from 'debug'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useMemo } from 'react'
import type { FileUploadAction } from '../ActionManager/FileUploadAction'
import { FileActionQueueDetailsItem } from './FileActionQueueDetailsItem'

const debug = Debug('jotta:publicfiles:VirtualActionQueueDetails')

export const FileActionQueueDetails = observer<{
  items: readonly FileUploadAction[]
  showDebugInfo?: boolean
  itemHeight: number
}>(function FileActionQueueDetails({
  items,
  showDebugInfo = false,
  itemHeight = 30,
}) {
  const scrollObservable = useElementSizeObservable({
    trackScrolling: true,
  })
  const options = useLocalObservable<VirtualListOptions<FileUploadAction>>(
    () => ({
      idKey: 'id',
      items,
      rowHeight: itemHeight,
      showDebugInfo,
      scrollObservable,
    }),
  )

  const longestFileName = useMemo(() => {
    const longest = items.reduce(
      (length, item) => (item.name.length > length ? item.name.length : length),
      0,
    )
    debug('Longest file name: %d', longest)
    return longest
  }, [items])

  return (
    <div
      sx={{
        '--filename-col-width': `${longestFileName / 2.5}em`,
        padding: 2,
        pb: 0,
        background: 'white',
        overflowY: 'auto',
        maxHeight: '50vh',
      }}
      ref={scrollObservable.ref}
    >
      <VirtualList
        options={options}
        className={styles['viewport--no-vertical']}
        renderItem={FileActionQueueDetailsItem}
      />
    </div>
  )
})
